import React, { type ReactElement } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "gatsby-plugin-react-i18next";

const Awards = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="mb-32 text-center">
      <div className="mb-5 flex h-auto max-w-full items-center justify-center">
        <StaticImage
          className="size-full max-w-[500px]"
          src="../assets/images/wta.png"
          placeholder="none"
          loading="eager"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="Awards"
        />
      </div>
      <h2>{t("bnesim_is_awards_winner")}</h2>
      <h3>{t("best_travel_sim_provider")}</h3>
    </div>
  );
};

export default Awards;
